import { defineMessages } from "react-intl";

const messages = defineMessages({
    buttonSignUpWithGoogle: {
        description: "Button Sign Up With Google",
        defaultMessage: "Sign up with Google"
    }
});

export default messages;
